import { focusComposedPath } from "../../common/helpers";
export const WINDOW_ID = "window";
export const ACTION_MENU_RENDER_TAG_NAME = "ch-action-menu-render";
export const ACTION_MENU_TAG_NAME = "ch-action-menu";
export const ACTION_MENU_SLOT_TAG_NAME = "slot";
const FIRST_ACTION_MENU = `:scope>${ACTION_MENU_TAG_NAME}`;
const LAST_ACTION_MENU = `:scope>${ACTION_MENU_TAG_NAME}:last-of-type`;
export const actionMenuItemIsActionable = (itemUIModel) => !itemUIModel.type || itemUIModel.type === "actionable";
export const actionMenuItemActionableIsExpandable = (itemUIModel) => itemUIModel.items !== undefined;
export const actionMenuItemIsHyperlink = (itemUIModel) => !!itemUIModel.link?.url;
export const getShadowRootOfEvent = (event) => {
    const composedPath = event.composedPath();
    const buttonIndex = composedPath.findIndex(el => {
        const tagName = (el.tagName ?? "").toLowerCase();
        return tagName === "button" || tagName === "a";
    });
    // The click event was not provoked by a button
    if (buttonIndex === -1) {
        return undefined;
    }
    const shadowRoot = composedPath[buttonIndex + 1];
    return shadowRoot instanceof ShadowRoot ? shadowRoot : undefined;
};
/**
 * @returns The model to update the expanded value or undefined if the click
 * was not performed on any valid item.
 */
export const getActionMenuInfoInEvent = (event) => {
    const shadowRoot = getShadowRootOfEvent(event);
    if (!shadowRoot) {
        return undefined;
    }
    const parentTagName = shadowRoot.host.tagName.toLowerCase();
    // The button does not belong to a ch-action-menu or ch-action-menu-render element
    if (parentTagName !== ACTION_MENU_TAG_NAME &&
        parentTagName !== ACTION_MENU_RENDER_TAG_NAME) {
        return undefined;
    }
    event.stopPropagation();
    return parentTagName === ACTION_MENU_RENDER_TAG_NAME
        ? ACTION_MENU_RENDER_TAG_NAME
        : {
            ref: shadowRoot.host,
            model: shadowRoot.host.model
        };
};
export const focusFirstActionMenuItem = (actionMenuRef) => actionMenuRef.querySelector(FIRST_ACTION_MENU)?.focus();
export const focusActionMenuLastItem = (actionMenuRef) => actionMenuRef.querySelector(LAST_ACTION_MENU)?.focus();
const getSiblingType = (nextSibling) => {
    const tagName = nextSibling.tagName?.toLowerCase();
    if (tagName === ACTION_MENU_TAG_NAME) {
        return ACTION_MENU_TAG_NAME;
    }
    return tagName === ACTION_MENU_SLOT_TAG_NAME
        ? ACTION_MENU_SLOT_TAG_NAME
        : undefined;
};
const findPreviousSibling = (element) => element.previousElementSibling;
const findNextSibling = (element) => element.nextElementSibling;
export const focusNextElement = (actionMenuInfo, findMode) => {
    const findFunction = findMode === "previous" ? findPreviousSibling : findNextSibling;
    let nextSibling = findFunction(actionMenuInfo.ref);
    while (nextSibling) {
        const siblingType = getSiblingType(nextSibling);
        // Keyboard navigation must be avoided if the next element is a slot
        if (siblingType === ACTION_MENU_SLOT_TAG_NAME) {
            return;
        }
        if (siblingType === ACTION_MENU_TAG_NAME &&
            !nextSibling.disabled) {
            return nextSibling.focus();
        }
        nextSibling = findFunction(nextSibling);
    }
};
export const actionMenuElementIsFocused = (actionMenuRef) => actionMenuRef === focusComposedPath()[1];
